import { r as registerInstance, h, H as Host } from './index-16dc7dde.js';

const pesSlideDownContainerCss = ":host{display:flex;transform:scaleY(0);transform-origin:100% 0;transition:transform 0.25s}:host(.active){transform:scaleY(1)}";

let PesSlideDownContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, { class: { active: this.active } }, h("slot", null)));
  }
};
PesSlideDownContainer.style = pesSlideDownContainerCss;

export { PesSlideDownContainer as pes_slide_down_container };
